export default __webpack_public_path__ + "static/media/ic_tail_96.d2cd8899.svg";